/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { Sheet } from "../../ui/sheet";
import { Button } from "../../ui/button";
import { setBasicDialogOpenFor } from "../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../store/hooks";
import { IAuditTrail } from "../../../store/api/admin/types";
import dayjs from "dayjs";
import { DATEFORMATS } from "../../../globals/globals";

interface IAuditModalProps {
    rowDetails: IAuditTrail;
    setRowDetails: React.Dispatch<React.SetStateAction<IAuditTrail | undefined>>
}

const AuditDetailsModal: React.FC<IAuditModalProps> = ({ rowDetails, setRowDetails }) => {
    const dispatch = useStoreDispatch();

    const OkHandler = () => {
        dispatch(setBasicDialogOpenFor(undefined));
        setRowDetails(undefined);
    }

    const footer = (
        <Button onClick={OkHandler}>
            OK
        </Button>
    );

    return (
        <Sheet
            open={true}
            onClose={OkHandler}
            title="Audit Details"
            footer={footer}
            width="640px"
            useCardStyle={false}
        >
            <div className="flex h-full flex-col">

                {/* Content */}
                <div className="flex-1 overflow-auto bg-background">

                    {/* Seq No */}
                    <div className="grid grid-cols-[180px_1fr] gap-6 border-b border-border py-2">
                        <div className="text-[15px] text-muted-foreground">
                            Seq no.
                        </div>

                        <div className="text-[15px] font-semibold text-foreground">
                            {rowDetails.id}
                        </div>
                    </div>

                    {/* Operation Time */}
                    <div className="grid grid-cols-[180px_1fr] gap-6 border-b border-border py-2">
                        <div className="text-[15px] text-muted-foreground">
                            Operation time & date
                        </div>

                        <div className="text-[15px] font-semibold text-foreground">
                            {dayjs(rowDetails.date).format(DATEFORMATS.TS)}
                        </div>
                    </div>

                    {/* Username */}
                    <div className="grid grid-cols-[180px_1fr] gap-6 border-b border-border py-2">
                        <div className="text-[15px] text-muted-foreground">
                            User name
                        </div>

                        <div className="text-[15px] font-semibold text-foreground">
                            {rowDetails.userId}
                        </div>
                    </div>

                    {/* Operation Name */}
                    <div className="grid grid-cols-[180px_1fr] gap-6 border-b border-border py-2">
                        <div className="text-[15px] text-muted-foreground">
                            Operation name
                        </div>

                        <div className="text-[15px] leading-8 text-foreground whitespace-pre-wrap break-words">
                            {rowDetails.action}
                        </div>
                    </div>

                    {/* Status */}
                    <div className="grid grid-cols-[180px_1fr] gap-6 py-2">
                        <div className="text-[15px] text-muted-foreground">
                            Operation status
                        </div>

                        <div className="text-[15px] font-semibold text-foreground">
                            {rowDetails.allowed ? "Allowed" : "Denied"}
                        </div>
                    </div>

                </div>
            </div>
        </Sheet>
    )
}
export default AuditDetailsModal;